<template>
  <div class="my-trips-sidebar">
    <h4 class="my-trips-sidebar__title">
      About <span>{{ trip.destination }}</span>
    </h4>
    <div class="my-trips-sidebar__description">
      {{ description }}
    </div>
    <div class="my-trips-sidebar__field">
      <div class="my-trips-sidebar__label">Location</div>
      <div class="my-trips-sidebar__value">
        {{ trip.destLocation }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AmexMyTripsDetailsSidebar',
  props: {
    trip: {
      type: Object,
      required: true,
    },
  },
  computed: {
    description() {
      const contexts = this.trip?.tripContexts || [];
      const context = !contexts.length ? {} : contexts[0];
      return context.description || '';
    },
  },
};
</script>

<style lang="scss" scoped>
.my-trips-sidebar {
  flex: 0 0 100vw;
  padding: 0 30px;

  &__title {
    font-size: 18px;
    line-height: 118.14%;
    letter-spacing: -0.005em;
    color: #071d3b;
    font-weight: 400;

    span {
      font-weight: 700;
    }
  }

  &__description {
    font-size: 14px;
    line-height: 118.14%;
    letter-spacing: -0.005em;
    color: rgba(7, 29, 59, 0.5);
    padding: 0 0 20px;
  }

  &__field {
    display: flex;
    padding: 15px 0;
    border-top: 1px solid #ededed;
  }

  &__label {
    flex: 0 0 80px;
    font-weight: 700;
    font-size: 12px;
    line-height: 118.14%;
    letter-spacing: -0.005em;
    color: #071d3b;
  }

  &__value {
    flex: 1;
    font-size: 13px;
    line-height: 118.14%;
    letter-spacing: -0.005em;
    color: rgba(7, 29, 59, 0.5);
  }
}
</style>
